const dayMs = 24 * 60 * 60 * 1000;

export const manilaDate = (now = new Date()) => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Manila', year: 'numeric', month: '2-digit', day: '2-digit'
}).format(now);

export const simDueState = (paidUntil, today = manilaDate()) => {
  if (!paidUntil) return 'unknown';
  const due = Date.parse(`${paidUntil}T00:00:00Z`);
  const base = Date.parse(`${today}T00:00:00Z`);
  if (Number.isNaN(due) || Number.isNaN(base)) return 'unknown';
  const days = Math.round((due - base) / dayMs);
  if (days < 0) return 'expired';
  if (days <= 7) return 'urgent';
  if (days <= 30) return 'soon';
  return 'ok';
};

export const formatManilaDate = (value) => {
  if (!value) return '-';
  const date = new Date(`${value}T00:00:00+08:00`);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-PH', { timeZone: 'Asia/Manila', year: 'numeric', month: 'short', day: '2-digit' }).format(date);
};
